import { toConnection } from '../../core';
import type { HandleRef } from '../../core';
import type { MindmapStoreApi } from '../../store';
import { isValidEnd } from './handleDom';

/**
 * Click-to-connect (v11 `connectOnClick`): the first click marks a start handle, the second click on a valid handle
 * connects; either way the second click clears the start.
 */
export const clickConnect = (store: MindmapStoreApi, doc: Document, handle: HandleRef, isConnectableStart: boolean): void => {
  const { clickConnectStart, connectionMode, connectHandlers, setClickConnectStart } = store.getState();
  if (!clickConnectStart) {
    if (isConnectableStart) setClickConnectStart(handle);
    return;
  }
  if (isValidEnd(doc, clickConnectStart, handle, connectionMode)) {
    connectHandlers.onConnect?.(toConnection(clickConnectStart, handle));
  }
  setClickConnectStart(null);
};
